module.exports = __webpack_public_path__ + "img/Dantam Hair 25.637adfa8.jpg";